<template>
    <div>
        <!-- Vincular Autorização Modal -->
        <div class="modal fade" id="vinculoAutorizMarcacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Solicitação de Autorização</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="alert alert-info" v-if="dados">
                            <div class="lead" v-if="dados.paciente || dados.cadastro_temporario">
                                {{ dados.paciente ? dados.paciente.st_nome : dados.cadastro_temporario.st_nome }}
                            </div>
                            <div v-if="dados.procedimento">
                                {{ dados.procedimento.search }}
                            </div>
                        </div>

                        <div v-if="autorizacoes" class="mb-3">
                            <template v-if="dados.paciente && dados.paciente.id_pessoa && !adicao_direta"> 
                                <button class="btn btn-sm" :class="autorizacoes.length ? 'btn-sm btn-outline-secondary' : 'btn-outline-success'" type="button" :disabled="$store.state.loading" @click="criar_ao_marcar()">
                                    Criar Solicitação de Autorização ao Marcar
                                </button>
                            </template>
                        </div>

                        <ul class="list-group" v-if="autorizacoes && autorizacoes.length > 0">
                            <li class="list-group-item" v-for="(item, iax) in autorizacoes" :key="iax">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h5>
                                            <span class="badge mr-2" :class="'badge-' + item.status_solicitacao.color">
                                                {{ item.status_solicitacao.msg }}
                                            </span>
                                            Autorização 
                                            <span class="small text-muted ml-2" title="Número da Solicitação">
                                                <i class="fa-solid fa-stamp"></i>
                                                {{ item.id_solicitacao_autorizacao }}
                                            </span>

                                            <span class="small text-muted ml-2" v-if="item.id_solicitacao_autorizacao_origem" title="Solicitação de origem">
                                                <i class="fa-solid fa-caret-right mr-2"></i>
                                                {{ item.id_solicitacao_autorizacao_origem }}
                                            </span>

                                            <span v-if="item.dt_valid_termino && item.status_solicitacao.color == 'success'">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                Validade: {{ $util.getFormatDate(item.dt_valid_termino) }}
                                            </span>
                                            <span v-if="item.condicao_validade" class="badge" :class="'badge-' + item.condicao_validade.color">
                                                {{ item.condicao_validade.msg }}
                                            </span>
                                        </h5>
                                        <div class="d-flex">
                                            <span>
                                                {{ item.procedimento.search }}
                                            </span>
                                        </div>
                                        <div class="small" v-if="item.outros_proc_lista">
                                            <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                            {{ item.outros_proc_lista }}
                                        </div>
                                        <div>
                                            <small>{{ item.medico.search }}</small> |
                                            <template v-if="item.unidade_operacao && item.unidade_operacao.st_sigla">
                                                <small>{{ item.unidade_operacao.st_sigla }}</small> |
                                            </template>
                                            <small v-if="item.plano">{{ item.plano.search }}</small> |
                                            <small>
                                                AUTORIZAÇÃO |
                                                {{ $util.getFormatDate (item.dt_solicitacao) }}
                                            </small>
                                        </div>
                                        <div class="small text-muted" v-if="item.st_comentarios" style="white-space: pre;">{{ item.st_comentarios }}</div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="text-right mr-2">
                                            <template v-if="dados.procedimento && ( item.id_procedimento == dados.procedimento.id_procedimento )">
                                                <button v-if="adicao_direta" class="btn btn-success"  :disabled="$store.state.loading"  type="button" @click="selecionar_autoriz(item, true)">
                                                    Selecionar
                                                </button>

                                                <div class="dropdown" v-else-if="dados.procedimento && ( item.id_procedimento == dados.procedimento.id_procedimento )">
                                                    <button class="btn btn-success dropdown-toggle" 
                                                        :disabled="$store.state.loading" 
                                                        type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        Marcar
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <a class="dropdown-item" href="#" @click="selecionar_autoriz(item)">Mesmo Profissional</a>
                                                        <div class="dropdown-divider"></div>
                                                        <a class="dropdown-item" href="#" @click="selecionar_autoriz(item, true)">Outro Profissional</a>
                                                    </div>
                                                </div>
                                            </template>

                                            <div class="dropdown" v-else-if="!adicao_direta && ( !item.geradas || !item.geradas.length )" >
                                                <button class="btn btn-sm dropdown-toggle" 
                                                    :disabled="$store.state.loading" 
                                                    :class="tem_autorizacao_do_procedimento() ? 'btn-outline-success' : 'btn-success'"
                                                    type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    Criar Solicitação
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item" href="#" @click.prevent="criar_autorizacao(item)">Mesmo Profissional</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" href="#" @click.prevent="criar_autorizacao(item, true)">Outro Profissional</a>
                                                </div>
                                            </div>

                                            <div v-if="item.qtde_pacote" class="mt-2">
                                                <h5>
                                                    <span class="badge badge-secondary">
                                                        x{{ item.qtde_pacote }}
                                                    </span>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row" v-if="item.clonar_para_outro">
                                    <div class="col col-12">
                                        <az-input
                                            icon="fa-solid fa-user-doctor fa-fw"
                                            placeholder="Selecione o Profissional..."
                                            type="autocomplete"
                                            optionsMode="aql"
                                            service="medicos.index"
                                            :optionsParm="{
                                                ativos: true,
                                                agenda: true,
                                                id_procedimento: item.id_procedimento
                                            }"
                                            required
                                            :validate="validate"
                                            v-model="item.outro_medico" />
                                    </div>
                                </div>
                                <div v-if="item.marcacoes && item.marcacoes.length > 0" class="mt-2">
                                    <div v-for="(marcacao, imx) in item.marcacoes" :key="imx">
                                        <div v-if="!item.marcacoes[0].ch_estado_marcacao || !imx">
                                            <span v-if="item.marcacoes.length > 1 && !imx" class="mr-2">
                                                <a href="#" @click.prevent="item.marcacoes[0].ch_estado_marcacao = !item.marcacoes[0].ch_estado_marcacao">
                                                    <i class="fa-regular fa-square-plus fa-fw" v-if="item.marcacoes[0].ch_estado_marcacao"></i>
                                                    <i class="fa-regular fa-square-minus fa-fw" v-else></i>
                                                </a>    
                                            </span>

                                            <span v-else class="mr-2">
                                                <i class="fa-solid fa-square fa-fw"></i>
                                            </span>

                                            {{ $util.getFormatDate(marcacao.dt_inicio) }}

                                            <span class="ml-2 small text-muted">
                                                {{ $util.getFormatDate(marcacao.dt_inicio, 'ddd') }}
                                            </span>

                                            <span v-if="marcacao.id_atendimento" class="ml-2">
                                                #{{ marcacao.id_atendimento }}
                                            </span>

                                            <span v-if="item.marcacoes.length > 1 && !imx" class="badge badge-secondary ml-2">
                                                {{ item.marcacoes.length }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <template v-if="false">
                            <pre class="alert alert-primary">{{ dados }}</pre>
                            <pre class="alert alert-warning">{{ autorizacoes }}</pre>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() {
        return { 
            dados: null, 
            autorizacoes: null,
            adicao_direta: false, 
        }
    },

    methods: { 
        fechar () { 
            $('#vinculoAutorizMarcacaoModal').modal('hide');
        },

        tem_autorizacao_do_procedimento() { 
            if ( !this.autorizacoes || !this.autorizacoes.length || !this.dados || !this.dados.procedimento )
                return false;
            
            return this.autorizacoes.find(autorizacao => {
                    return autorizacao.id_procedimento == this.dados.procedimento.id_procedimento;
                }) 
                ? true 
                : false;
        },

        selecionar_autoriz(item, outro = false) { 
            $('#vinculoAutorizMarcacaoModal').modal('hide');

            let solic = _.cloneDeep(item);

            if ( this.adicao_direta ) { 
                solic.manter_medico = true;
            }

            if ( outro ) { 
                solic.medico = null; 
            }
            
            this.$emit('selecionar', solic);
        },

        criar_ao_marcar () { 
            let fake_autoriz = { 
                ...this.dados,
                id_solicitacao_autorizacao: -1, 
            };

            this.selecionar_autoriz(fake_autoriz);
        },

        criar_autorizacao (item, outro = false) { 

            if ( !confirm('Confirmar gerar a solicitação de autorização para ' + this.dados.procedimento.search + '?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'clonar',
                dados: { 
                    id_solicitacao_autorizacao: item.id_solicitacao_autorizacao,
                    id_procedimento: this.dados.procedimento.id_procedimento,
                    dt_solicitacao: this.$util.hoje(),
                },
                toast: true, 
                callback: res => { 
                    if ( res.nova && res.nova.id_solicitacao_autorizacao && res.nova.id_procedimento == this.dados.procedimento.id_procedimento ) { 

                        if ( outro ) { 
                            res.nova.medico = null;
                        }

                        this.selecionar_autoriz(res.nova);
                    } else { 
                        this.abrir([this.procedimento]);
                    }
                }
            });

        },

        abrir(procedimento, adicao_direta = false) { 

            this.adicao_direta = adicao_direta;

            if ( procedimento && procedimento.length == 1 ) { 

                this.autorizacoes = null;
                this.dados = _.first(procedimento);

                if ( !this.dados.paciente && !this.dados.cadastro_temporario ) { 
                    return;
                }

                this.$util.load(this, { 
                    service: 'solicitacao_autorizacoes',
                    func: 'index',
                    parms: { 
                        paciente: { 
                            id_pessoa: this.dados.paciente ? this.dados.paciente.id_pessoa : null, 
                            id_cadastro_temporario: this.dados.cadastro_temporario ? this.dados.cadastro_temporario.id_cadastro_temporario : null
                        },
                        agendando: true,
                        para_agendar: true, 
                    },
                    loadTo: res => { 
                        this.autorizacoes = res;
                    }
                });

                $('#vinculoAutorizMarcacaoModal').modal('show');

            }

            
        }
    }
}
</script>
